import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {VideoPlatformConfig} from '../video-platforms';
import {VideoInfo, VideoPlatformId, VideoRow} from '../video-types';

interface VideoPreviewResponse {
  preview?: string;
  title?: string;
}

export class VkPlatform extends VideoPlatformConfig {
  readonly name = 'VK';
  readonly id = VideoPlatformId.VK;
  readonly patterns = [
    /^https?:\/\/(?:www\.)?(?:vkvideo\.ru|vksport\.vkvideo\.ru)\/video(-?\d+_\d+)/,
    /^https?:\/\/(?:www\.)?vk\.com\/video(-?\d+_\d+)/,
    /^https?:\/\/(?:www\.)?vk\.com\/video\?.*z=video(-?\d+_\d+)/
  ];
  readonly exampleLink = 'https://vkvideo.ru/video-226869005_456239101';

  constructor(private readonly serverApi: string) {
    super();
  }

  getEmbedUrl(row: VideoRow): string {
    const code = this.getVideoCode(row);
    if (!code) {
      return '';
    }
    const [oid, id] = code.split('_');
    return oid && id ? `https://vk.com/video_ext.php?oid=${oid}&id=${id}&hd=2` : '';
  }

  // VK oEmbed API удалён — используем бэкенд-прокси для получения og:image
  getInfo(row: VideoRow, http: HttpClient): Observable<VideoInfo> {
    const url = row.link;
    if (!url) {
      return this.createEmptyInfo(row);
    }

    return http.get<VideoPreviewResponse>(
      `${this.serverApi}/proxy/video-preview`,
      {params: {url}}
    ).pipe(
      map(resp => ({
        link: url,
        preview: resp?.preview || '',
        title: resp?.title || ''
      })),
      catchError(() => this.createEmptyInfo(row))
    );
  }
}
